import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function Problem() {
  return <Section dark className="bg-navy-light" data-id="element-124">
      <div className="max-w-4xl mx-auto" data-id="element-125">
        <div className="text-center mb-16" data-id="element-126">
          <h2 className="text-3xl md:text-4xl font-serif mb-6 text-gold-light" data-id="element-127">
            El problema con los "Gurús" de 20 años
          </h2>
          <p className="text-xl text-cream-dark font-light" data-id="element-128">
            La mayoría de los cursos de redes sociales están diseñados por
            jóvenes de 20 años para gente de 20 años.
          </p>
        </div>

        <div className="bg-navy p-8 md:p-12 rounded-sm border border-gold/20 shadow-2xl" data-id="element-129">
          <p className="text-lg leading-relaxed mb-8 font-light text-cream-dark" data-id="element-130">
            Te dicen que necesitas ser "vulnerable", que sigas el audio de moda
            o que publiques 5 veces al día hasta el agotamiento.
          </p>
          <p className="text-lg leading-relaxed mb-8 font-light text-cream-dark" data-id="element-131">
            Para la mujer profesional de más de 45 años, ese camino no solo es
            agotador, sino que{' '}
            <strong className="text-gold-light font-normal" data-id="element-132">
              destruye su credibilidad
            </strong>
            . Intentar copiar a la Generación Z es lo que realmente te hace
            parecer fuera de lugar.
          </p>
          <div className="p-6 bg-gold/10 border-l-4 border-gold italic text-cream" data-id="element-133">
            "La falta de una estrategia visual madura es lo que te mantiene
            invisible ante los clientes que sí pueden pagar por tu
            conocimiento."
          </div>
        </div>

        <div className="mt-20" data-id="element-134">
          <h3 className="text-2xl font-serif text-center mb-10 text-cream" data-id="element-135">
            Por qué lo que intentaste no funcionó:
          </h3>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-136">
            {['Intentaste usar filtros de belleza exagerados que solo lograron que tu audiencia no confiara en tu autenticidad.', 'Seguiste guiones de marketing genéricos que te hacían sonar como un robot en lugar de una experta.', 'Trataste de humanizar tu marca siguiendo tendencias que no van con tu personalidad, sacrificando tu dignidad profesional en el proceso.', "Te enfocaste en conseguir 'vistas' de desconocidos en lugar de generar 'respeto' en posibles clientes."].map((item, index) => <div key={index} className="flex items-start space-x-4 bg-navy p-6 rounded-sm border border-white/5" data-id="element-137">
                <XCircle className="w-6 h-6 text-red-400/80 shrink-0 mt-1" data-id="element-138" />
                <p className="text-cream-dark font-light text-sm md:text-base" data-id="element-139">
                  {item}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}